// extracted by mini-css-extract-plugin
module.exports = {"cart":"style_cart__gT_mh","items":"style_items__zMflD","total":"style_total__qhCAA","footer":"style_footer__7wpc_","busy":"style_busy__FENHJ"};